import React from 'react'

export default function Topbar() {
  return (
    <div className="d-none d-md-block">
      <div className="container-fluid bg-dark">
        <div className="row py-2 px-md-3 px-lg-5">
          <div className="col-md-6 text-md-left text-center mb-2 mb-md-0">
            <div className="d-inline-flex align-items-center text-white justify-content-md-start justify-content-center w-100">
              <small><i className="fa fa-phone-alt mr-2"></i></small>
              <small className="px-3">+91-93800 62572</small>
              <small><i className="fa fa-envelope mr-2"></i>cc.schooled@gmail.com</small>
            </div>
          </div>
          <div className="col-md-6 text-md-right text-center">
            <div className="d-inline-flex align-items-center justify-content-md-end justify-content-center w-100">
              <a className="text-white px-2" href="">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a className="text-white px-2" href="">
                <i className="fab fa-twitter"></i>
              </a>
              <a className="text-white px-2" href="">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a className="text-white px-2" href="">
                <i className="fab fa-instagram"></i>
              </a>
              <a className="text-white pl-2" href="">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
